import { Campaign } from "../types";

function startOfDay(iso: string): number {
  const [y, m, d] = iso.split("-").map(Number);
  return new Date(y, m - 1, d).getTime();
}

function endOfDay(iso: string): number {
  const [y, m, d] = iso.split("-").map(Number);
  return new Date(y, m - 1, d, 23, 59, 59, 999).getTime();
}

export function isCampaignActive(campaign: Campaign, now: Date = new Date()): boolean {
  const t = now.getTime();
  return t >= startOfDay(campaign.startsAt) && t <= endOfDay(campaign.endsAt);
}

export function activeCampaigns(campaigns: Campaign[], now: Date = new Date()): Campaign[] {
  return campaigns.filter((c) => isCampaignActive(c, now));
}
